import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=db7e222c&scoped=true&"
import script from "./productCenter.vue?vue&type=script&lang=js&"
export * from "./productCenter.vue?vue&type=script&lang=js&"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=db7e222c&lang=scss&scoped=true&"
import style1 from "./productCenter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7e222c",
  null
  
)

export default component.exports